"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Alert = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _Layout = require("../Layout");

var _Icon = require("../Icon");

var _Icons = require("../Icons");

var StyledAlert = (0, _styledComponents.default)(_Layout.Box).withConfig({
  displayName: "Alert__StyledAlert",
  componentId: "sc-1lws2bu-0"
})({
  width: '100%',
  position: 'relative',
  display: 'flex'
}, (0, _styledSystem.variant)({
  prop: 'withShadow',
  variants: {
    true: {
      borderWidth: '0',
      borderColor: 'none',
      boxShadow: 'borders.sonar.completeLight'
    }
  }
}), (0, _styledSystem.variant)({
  prop: 'type',
  variants: {
    warning: {
      backgroundColor: 'cebolla'
    },
    error: {
      backgroundColor: 'status.danger',
      color: 'coco'
    },
    success: {
      backgroundColor: 'status.success',
      color: 'coco'
    },
    info: {
      backgroundColor: 'coco',
      borderWidth: '1px',
      borderColor: 'durian',
      borderStyle: 'solid'
    }
  }
}), (0, _styledSystem.variant)({
  prop: 'size',
  variants: {
    small: {
      paddingY: 4,
      paddingX: 5
    },
    large: {
      paddingX: 6,
      paddingY: 6
    }
  }
}), _styledSystem.background);
var AlertCloseIconStyled = (0, _styledComponents.default)(_Icon.Icon).withConfig({
  displayName: "Alert__AlertCloseIconStyled",
  componentId: "sc-1lws2bu-1"
})({
  cursor: 'pointer'
});

var Alert = function Alert(_ref) {
  var children = _ref.children,
      size = _ref.size,
      withShadow = _ref.withShadow,
      onCloseAlert = _ref.onCloseAlert,
      isClosable = _ref.isClosable,
      id = _ref.id,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children", "size", "withShadow", "onCloseAlert", "isClosable", "id"]);
  var alertRef = (0, _react.useRef)();
  return _react.default.createElement(StyledAlert, (0, _extends2.default)({
    size: size,
    borderRadius: 1,
    id: id,
    withShadow: withShadow,
    ref: alertRef
  }, props), _react.default.createElement(_Layout.Box, {
    flexGrow: "1"
  }, children), isClosable && _react.default.createElement(AlertCloseIconStyled, {
    onClick: function onClick(e) {
      var _alertRef$current;

      e.preventDefault();
      alertRef === null || alertRef === void 0 ? void 0 : (_alertRef$current = alertRef.current) === null || _alertRef$current === void 0 ? void 0 : _alertRef$current.remove();
      if (onCloseAlert) onCloseAlert(id);
    }
  }, _react.default.createElement(_Icons.Close, null)));
};

exports.Alert = Alert;
Alert.defaultProps = {
  type: 'info',
  size: 'small',
  isClosable: false,
  withShadow: false
};